module.exports = __webpack_public_path__ + "static/img/index-bg.11c7b1ff.png";